import { useContext, useMemo } from "react";

import AddPageSubMenu from "src/components/layouts/AddPageSubMenu";
import InstitutionIdentityContext from "src/contexts/data/InstitutionIdentityContext";
import { createInstitutionSubMenu } from "src/routing/navigation";

/**
 * Registers the institution submenu through the shared layout adapter.
 *
 * Postconditions: A rendered registration requests layout updates after render and removes its
 * submenu code on cleanup. Navigation factories retain responsibility for link metadata.
 * Missing required identities yield no registration. Identity references control recomputation.
 */
const InstitutionSubMenu: React.FC = () => {
    const { data: institutionIdentity } = useContext(InstitutionIdentityContext);

    const subMenu = useMemo(
        () => {
            if (!institutionIdentity) {
                return null;
            }

            return createInstitutionSubMenu(institutionIdentity);
        },
        [institutionIdentity]
    );

    if (!subMenu) {
        return null;
    }

    return <AddPageSubMenu subMenu={subMenu} />;
};

export default InstitutionSubMenu;
